import { get } from "lodash";
import React, { useEffect, useState } from "react";

import "./more-stories-from-author.m.css";
import AuthorImage from "../AuthorImage";
import { getAuthorStories } from "../../../../../api/utils";
import { Link } from "@quintype/components";
import { handleAuthorInteraction } from "../../../../ga-utils";
import CircleIcon from "../../../../components/atoms/Circle";
import { MORE_FROM_AUTHORS_TITLE } from "../../../../constants";

const MoreStoriesFromAuthor = ({ story = {}, config, pageType = "story-page" }) => {
  if (!story) return null;

  const [stories, setStories] = useState([]);

  const author = get(story, ["authors", [0]], null);

  if (!author) return null;

  useEffect(() => {
    if (author) {
      getAuthorStories(author.id, 0, 5)
        .then((authorStories) => {
          // Filter out the current story and take only 4 stories
          const filteredStories = authorStories
            .filter((authorStory) => authorStory.story?.id !== story.id)
            .map((authorStory) => authorStory.story) // Extract the nested story object
            .slice(0, 4);

          setStories(filteredStories);
        })
        .catch((error) => {
          console.error("Error fetching author stories:", error);
        });
    }
  }, [author, story.id]);

  const generateHeadlineWithPen = (storyItem) => {
    return (
      <div styleName="headline-wrapper">
        <CircleIcon />
        <Link href={storyItem.slug}>
          <div styleName="headline">{storyItem.headline}</div>
        </Link>
      </div>
    );
  };

  if (stories.length < 1) {
    return null;
  }

  const authorUrl = `/author/${author.slug}`;

  return (
    <div>
      <div styleName="header">
        <div styleName="title">{MORE_FROM_AUTHORS_TITLE}</div>
        <div styleName="author-wrapper">
          <AuthorImage author={author} isClickable={true} />
          <Link
            href={authorUrl}
            disableAjaxLinks={true}
            onTouchStart={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
            onMouseDown={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
          >
            <div styleName="author-name">{author.name}</div>
          </Link>
        </div>
      </div>
      <div styleName="stories-wrapper">
        <div styleName="top-stories">{stories.slice(0, 2).map((storyItem) => generateHeadlineWithPen(storyItem))}</div>
        {stories.length > 2 && (
          <div styleName="bottom-stories">
            {stories.slice(2, 4).map((storyItem, index) => generateHeadlineWithPen(storyItem))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreStoriesFromAuthor;
